var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTeamBuilder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M64 14.454v41.788H0V14.454l3.75-3.787h56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADAE5",
    d: "M64 14.454v41.788H32V10.667h28.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474F54",
    d: "M0 0h64v15.515H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32393F",
    d: "M32 0h32v15.515H32z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF637B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.758 5.818h3.685v3.879H7.758zM15.128 5.818h3.685v3.879h-3.685zM22.497 5.818h3.685v3.879h-3.685z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF637B",
    d: "M45.576 42.245V64H34.355v-3.71h-3.74V64H19.394V42.245l11.37-9.275h3.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADAE5",
    d: "M11.636 22.303h41.697v3.879H11.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9D3",
    d: "M32 22.303h20.364v3.879H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E63950",
    d: "M45.576 42.245V64H33.939v-3.71H32V32.97h1.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M30.061 45.576h3.878v3.879h-3.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADAE5",
    d: "M32 45.576h1.939v3.879H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676E74",
    d: "M50.424 45.779l-2.452 2.706-15.487-13.526-15.488 13.526-2.452-2.706 17.94-15.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474F54",
    d: "M32 30.061l18.424 15.718-2.518 2.706L32 34.959z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamBuilder);
export default __webpack_public_path__ + "static/media/icon-team-builder.b885fb580a3cb78c9ad249750dd65a01.svg";
export { ForwardRef as ReactComponent };